import classNames from "classnames";
import { Fragment } from "react";

const headers = [
  "Currency",
  "Merchant Fee",
  "Gateway Fee",
  "Payout Fee",
  "Monthly Subscription Fee",
  "Refund Gateway Fee",
];

export const ZbooniFees = () => {
  return (
    <Fragment>
      <div className="flow-root overflow-x-auto">
        <h1 className="font-medium mb-4">All in One*</h1>
        <div className="border inline-block rounded-md align-middle">
          <table className="divide-y min-w-[890px] divide-gray-300">
            <thead>
              <tr className="text-[11px] text-left font-bold divide-x divide-gray-200">
                {headers.map((header, index) => (
                  <th
                    key={index}
                    scope="col"
                    className={classNames(
                      "whitespace-nowrap min-w-[135px] first-of-type:rounded-tl-md last-of-type:rounded-tr-md h-9 px-4 leading-4 bg-secondary-darkest text-white",
                      index == 0 && "w-[135px]"
                    )}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y text-[9.5px] font-semibold divide-gray-200 bg-white">
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 leading-4 bg-lightgray border-b border-white">
                  <span>AED</span>{" "}
                  <span className="font-normal">
                    (United Arab Emirates Dirham)
                  </span>
                </td>
                <td rowSpan={4} className="h-11 px-4">
                  3.5%
                </td>
                <td className="h-11 px-4">AED 1</td>
                <td className="h-11 px-4">AED 10</td>
                <td rowSpan={5} className="h-11 px-4">
                  0
                </td>
                <td className="h-11 px-4">AED 1</td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 leading-4 bg-lightgray border-b border-white">
                  <span>EGP</span>{" "}
                  <span className="font-normal">(Egyptian Pound)</span>
                </td>
                <td className="h-11 px-4">EGP 1</td>
                <td className="h-11 px-4">EGP 50</td>
                <td className="h-11 px-4">EGP 1</td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 leading-4 bg-lightgray border-b border-white">
                  <span>SAR</span>{" "}
                  <span className="font-normal">(Saudi Riyal)</span>
                </td>
                <td className="h-11 px-4">SAR 1</td>
                <td className="h-11 px-4">SAR 8.05</td>
                <td className="h-11 px-4">SAR 1</td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 leading-4 bg-lightgray border-b border-white">
                  <span>JOD</span>{" "}
                  <span className="font-normal">(Jordanian Dinar)</span>
                </td>
                <td className="h-11 px-4">JOD 0.2</td>
                <td className="h-11 px-4">JOD 3.5</td>
                <td className="h-11 px-4">JOD 0.2</td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 leading-4 bg-lightgray border-b border-white">
                  <span>USD</span>{" "}
                  <span className="font-normal">(United States Dollar)</span>
                </td>
                <td rowSpan={7} className="h-11 px-4">
                  4.5%
                </td>
                <td className="h-11 px-4">USD 0.27</td>
                <td className="h-11 px-4">USD 24</td>
                <td className="h-11 px-4">USD 0.27</td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 leading-4 bg-lightgray border-b border-white">
                  <span>GBP</span>{" "}
                  <span className="font-normal">(Pound Sterling)</span>
                </td>
                <td className="h-11 px-4">GBP 0.8</td>
                <td className="h-11 px-4">GBP 19.68</td>
                <td rowSpan={6} className="h-11 px-4">
                  15 USD
                </td>
                <td className="h-11 px-4">GBP 0.2</td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 leading-4 bg-lightgray border-b border-white">
                  <span>EUR</span>{" "}
                  <span className="font-normal">(Europe Sterling)</span>
                </td>
                <td className="h-11 px-4">EUR 0.25</td>
                <td className="h-11 px-4">EUR 22.08</td>
                <td className="h-11 px-4">EUR 0.25</td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 leading-4 bg-lightgray border-b border-white">
                  <span>OMR</span>{" "}
                  <span className="font-normal">(Omani Rial)</span>
                </td>
                <td className="h-11 px-4">OMR 0.1</td>
                <td className="h-11 px-4">OMR 9.04</td>
                <td className="h-11 px-4">OMR 0.1</td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 leading-4 bg-lightgray border-b border-white">
                  <span>BHD</span>{" "}
                  <span className="font-normal">(Bahraini Dinar)</span>
                </td>
                <td className="h-11 px-4">BHD 0.1</td>
                <td className="h-11 px-4">BHD 8.84</td>
                <td className="h-11 px-4">BHD 0.1</td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 leading-4 bg-lightgray border-b border-white">
                  <span>QAR</span>{" "}
                  <span className="font-normal">(Qatari Riyal)</span>
                </td>
                <td className="h-11 px-4">QAR 1</td>
                <td className="h-11 px-4">QAR 87.36</td>
                <td className="h-11 px-4">QAR 1</td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 leading-4 bg-lightgray">
                  <span>KWD</span>{" "}
                  <span className="font-normal">(Kuwaiti Dinar)</span>
                </td>
                <td className="h-11 px-4">KWD 0.1</td>
                <td className="h-11 px-4">KWD 7.20</td>
                <td className="h-11 px-4">KWD 0.1</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="font-semibold text-[10px] mt-2.5">
          *VAT will be charged extra to the above fees
        </p>
      </div>
      <div className="my-8 flow-root overflow-x-auto">
        <h1 className="font-medium mb-4">Integrated</h1>
        <div className="border inline-block rounded-md align-middle">
          <table className="table-fixed divide-y min-w-[300px] w-full max-w-[810px] divide-gray-300">
            <tbody className="divide-y text-[9.5px] leading-4 font-semibold divide-gray-200 bg-white">
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 bg-lightgray border-b border-white">
                  Setup Fees
                </td>
                <td className="h-11 px-4">USD 299 (one time set-up fee)</td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 bg-lightgray border-b border-white">
                  Monthly Subscription
                </td>
                <td className="h-11 px-4">Nil</td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 bg-lightgray">Commission</td>
                <td className="h-11 px-4">3.5% per order + VAT</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="flow-root overflow-x-auto">
        <h1 className="font-medium mb-4">Custom</h1>
        <div className="border inline-block rounded-md align-middle">
          <table className="table-fixed divide-y min-w-[300px] w-full max-w-[810px] divide-gray-300">
            <tbody className="divide-y text-[9.5px] leading-4 font-semibold divide-gray-200 bg-white">
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 bg-lightgray border-b border-white">
                  Setup Fees
                </td>
                <td rowSpan={3} className="h-11 px-4">
                  Please refer to your specific Custom Service Module Policy, if
                  applicable.
                </td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 bg-lightgray border-b border-white">
                  Monthly Subscription
                </td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="h-11 px-4 bg-lightgray">Commission</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Fragment>
  );
};
